import Router from "next/router";
import {
  IMobileFlow,
  IOfferModeWithFSecure,
} from "@nju/data-access-portal-offers";
import { resolvePathFromOrchestratorState } from "./resolvePathFromOrchestratorState";
import { IExtendedOnboardingOrchestratorState } from "./types";

type Query = {
  [key in IExtendedOnboardingOrchestratorState]?: Record<string, string>;
};
interface IRedirectToOrchestratorStateProps {
  state: IExtendedOnboardingOrchestratorState;
  mode: IOfferModeWithFSecure;
  query?: Query;
  flow?: IMobileFlow;
}

export function redirectToOrchestratorState({
  state,
  mode,
  query,
  flow,
}: IRedirectToOrchestratorStateProps) {
  Router.push({
    pathname: resolvePathFromOrchestratorState({ state }),
    query: query
      ? { mode, ...query[state], ...(flow && { flow }) }
      : { mode, ...(flow && { flow }) },
  });
}
